export default __webpack_public_path__ + "img/500247eb6302b32c6a39e88a8cf47b0a.svg";